import { createSlice } from "@reduxjs/toolkit"
import { buyElixir } from "../apis/elixirsAPI/index"
import { getAllTools } from "../apis/toolsAPI/index"
import { IToolInstance } from "../apis/toolsAPI/types"
import { IElixirInstance } from "../apis/elixirsAPI/types"

export interface InventoryState {
  activeTool: IToolInstance | null
  tools: IToolInstance[]
  elixirs: IElixirInstance[]
  preforms: any[]
}

const initialState: InventoryState = {
  activeTool: null,
  tools: [],
  elixirs: [],
  preforms: []
}

const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    updateElixirListOnActivateOne: (state, { payload }) => {
      state.elixirs = state.elixirs
        .map((elixir) => {
          if (elixir._id === payload._id) {
            if (elixir.count > 1) {
              return { ...elixir, count: elixir.count - 1 }
            }
            return null
          }
          return elixir
        })
        .filter((el) => !!el)
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(buyElixir.matchFulfilled, (state, { payload }) => {
      const { elixirInstance } = payload

      state.elixirs = state.elixirs.filter(
        (elixir) => elixir.elixir !== elixirInstance.elixir
      )

      state.elixirs.push(elixirInstance)
    })

    builder.addMatcher(getAllTools.matchFulfilled, (state, { payload }) => {
      state.tools = payload.items
      state.activeTool = payload.items.find((t) => t.isActive) || null
    })
  }
})

export default inventorySlice
